import React from 'react';
import Popup from '@components/Popup';
import { FEMALE_USER_RANK } from '@constants/constant';

const IncreaseInPointsAwardedPopup = ({
  isVisible,
  onClose,
  userCurrentRank,
  userCurrentRankText,
  onPositiveClicked
}) => {
  // ブラックとダイヤ以外のユーザーはこのpopupに辿り着けない想定
  const description =
    userCurrentRank === FEMALE_USER_RANK.BLACK
      ? 'デート参加１回につき500pt,\n高評価で500pt,\nブラック男性とデートでさらに500pt\nGETできるようになりました'
      : 'デート参加１回につき500pt,\n高評価で500ptをGET\nできるようになりました';

  return (
    <Popup
      visible={isVisible}
      title={'付与ポイント増加のお知らせ'}
      positiveButtonTitle="ポイントを確認する"
      MessagesComponent={
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p>{userCurrentRankText}ランクへ昇格したため</p>
          <p>{description}</p>
        </div>
      }
      onPositiveClicked={onPositiveClicked}
      negativeButtonTitle="閉じる"
      onNegativeClicked={onClose}
    />
  );
};

export default IncreaseInPointsAwardedPopup;
